import React, { useEffect } from "react";
import HeaderOne from "../common/header/Header";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import ProjectComponents from "../components/project/ProjectComponent";
import { useLocation } from "react-router-dom";
import SEO from "../common/seo/SEO";
import PartnerShipCta from "../components/cta/PartnerShip";

const Projects = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <SEO path={"/projects"} prefix={"Projects"} />

      <HeaderOne />
      <Breadcrumb heading="Our Projects" currentPage="Projects" />
      <ProjectComponents />
      <PartnerShipCta />
      <Footer />
    </>
  );
};

export default Projects;
